/****************************************************************************
 * COPYRIGHT (c) 2025 Harman Connected Services
 *
 * All rights reserved
 *
 * This software embodies materials and concepts which are
 * confidential to Ignite Product and is made available solely
 * pursuant to the terms of a written license agreement with
 * Ignite Product.
 *
 * Designed and Developed by Harman International Industries, Inc.
 ***************************************************************************/

import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import "./PortfolioDomainSettings.css";
import Topheader from "../../../Layout/header/header";
import {
  fetchDomainClusterDetails,
  fetchPostDomainClusterDetails,
} from "../../../Services/redux/domain-approver-cluster/DomainApproverClusterActions";
import AddClusterModal from "./AddClusterModal";
import SideMenuDAsettings from "./sideMenuDAsettings";
import GlobalAdminCategories from "../../global-admin/categories/GlobalAdminCategories";
import EcuType from "./EcuType";
// SDD01MARKETPLACE946R120:
// CODE01MARKETPLACE946R120: View all ECU Types mapped to makes within domain
// Related items (auto-generated):
// End related items
// SDD02MARKETPLACE946R120:
// CODE02MARKETPLACE946R120: Add a new ECU Type for a specific make
// Related items (auto-generated):
// End related items
// SDD03MARKETPLACE946R120:
// CODE03MARKETPLACE946R120: Delete an ECU Type from a make
// Related items (auto-generated):
// End related items
// SDD04MARKETPLACE946R120:
// CODE04MARKETPLACE946R120: Prevent adding duplicate ECU Types for the same make
// Related items (auto-generated):
// End related items
// SDD05MARKETPLACE946R120:
// CODE05MARKETPLACE946R120: View all Make Model Year combinations in domain
// Related items (auto-generated):
// End related items
// SDD06MARKETPLACE946R120:
// CODE06MARKETPLACE946R120: Add a new Make Model Year combination
// Related items (auto-generated):
// End related items
// SDD07MARKETPLACE946R120:
// CODE07MARKETPLACE946R120: Edit the year field of an existing MMY entry
// Related items (auto-generated):
// End related items
// SDD08MARKETPLACE946R120:
// CODE08MARKETPLACE946R120: Prevent adding duplicate Make Model Year combinations
// Related items (auto-generated):
// End related items

const PortfolioDomainSettings = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const [displayClusters, setDisplayClusters] = useState([]);
  const { clusterDetails, loading, error } = useSelector(
    (state) => state.domainApproverCluster,
  );

  const [openPopup, setOpenPopup] = useState(false);
  const [activeMenu, setActiveMenu] = useState(
    location.state?.activeMenu || "ECU Types"
  );

  const handleMenuItemClick = (menu) => {
    setActiveMenu(menu);
  };

  const openAddCluster = () => {
    setOpenPopup(true);
  };

  const closeAddCluster = () => {
    setOpenPopup(false);
  };

  const addNewClusters = (data) => {
    let obj = {};
    obj["clusterNumbers"] = [data];
    dispatch(fetchPostDomainClusterDetails(obj));
  };

  useEffect(() => {
    dispatch(fetchDomainClusterDetails());
  }, []);

  useEffect(() => {
    if (
      clusterDetails &&
      Object.keys(clusterDetails).length > 0 &&
      clusterDetails?.clusterNumbers.length > 0
    ) {
      setDisplayClusters(clusterDetails.clusterNumbers);
    }
  }, [clusterDetails, displayClusters]);

  const isVWDomainApprover = sessionStorage.getItem("idpLogin") === "true";

  return (
    <div className="portfolio-domain-settings">
      <Topheader />

      <div className="portfolio-settings">
        <div className="portfolio-settings-side-menu">
          <SideMenuDAsettings
            activeMenu={activeMenu}
            handleMenuItemClick={handleMenuItemClick}
            isVWDomainApprover={isVWDomainApprover}
          />
        </div>

        <div className="portfolio-settings-content">
          {activeMenu === "Make Model Year" && (
            <div className="make-model-year-section">
              <GlobalAdminCategories isDomainApprover={true} />
            </div>
          )}
          {activeMenu === "ECU Types" && (
            <div className="ecu-type-section">
              <EcuType />
            </div>
          )}
          {activeMenu === "Categories" && (
            <div className="categories-section">
              <GlobalAdminCategories isDomainApprover={true} initialSection="Categories" />
            </div>
          )}
          {activeMenu === "Clusters" && isVWDomainApprover && (
            <div className="cluster-management-section">
              <div className="cluster-management-header">
                <h2>Cluster Management</h2>
                <button
                  className={
                    sessionStorage.getItem("readonly_DomainApprover") === "true"
                      ? "add-cluster-btn disable-add-cluster-btn"
                      : "add-cluster-btn"
                  }
                  onClick={openAddCluster}
                >
                  <span className="add-icon">+</span> Add Cluster
                </button>
                <AddClusterModal
                  open={openPopup}
                  handleClose={closeAddCluster}
                  addNewClusters={addNewClusters}
                  existingClusters={displayClusters}
                />
              </div>

              <div className="cluster-table-container">
                {loading && (
                  <div className="loading-message">Loading clusters...</div>
                )}
                {!loading && error && (
                  <div className="error-message">
                    Error loading clusters:{" "}
                    {typeof error === "object"
                      ? error.message || JSON.stringify(error)
                      : error}
                  </div>
                )}
                {!loading && !error && (
                  <table className="cluster-table">
                    <thead>
                      <tr>
                        <th>Sl. No</th>
                        <th>Cluster</th>
                      </tr>
                    </thead>
                    <tbody>
                      {displayClusters.map((item, index) => (
                        <tr key={item.id}>
                          <td>{index + 1}</td>
                          <td>{item}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PortfolioDomainSettings;
